<!-- <h1 mat-dialog-title>{{ 'LoginModal.AccountRegistration' | translate }}</h1> -->
<mat-dialog-content>
  @if(this.dialog ==='two'){
    <p>{{ 'LoginModal.RegistrationDialog1' | translate }}</p>
   }
    @if(this.dialog ==='one'){
    <p>{{ 'Errors.emailAddressInUse' | translate }}</p>
    }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>{{ 'LoginModal.Close' | translate }}</button>
</mat-dialog-actions>